<template>
  <div>
    <div>
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
  defineOptions({
    name: 'Blank',
  });
</script>
